var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1562 21.3125C10.9219 21.5469 10.5938 21.5469 10.3594 21.3125L0.46875 11.4219C0.234375 11.1875 0.234375 10.8594 0.46875 10.625L10.3594 0.734375C10.5938 0.5 10.9219 0.5 11.1562 0.734375L11.4844 1.0625C11.7188 1.29688 11.7188 1.625 11.4844 1.85938L2.34375 11L11.4844 20.1875C11.7188 20.4219 11.7188 20.75 11.4844 20.9844L11.1562 21.3125Z",
    fill: "#A98970"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.6b8b3ce8a61409f37bdeb396b964de53.svg";
export { ForwardRef as ReactComponent };